import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import {
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';

import {
  navigate,
} from '../../actions';

import TransferFunds from './TransferFunds';
import TransferReview from './TransferReview';
import TransferConfirmed from './TransferConfirm';
import TransferError from './TransferError';

export const routes = [
  {
    step: 'Transfer Funds',
    path: 'transfer',
    Comp: TransferFunds,
  },
  {
    step: 'Review Transfer',
    path: 'review',
    Comp: TransferReview,
  },
  {
    step: 'Transfer Confirmed',
    path: 'confirmed',
    Comp: TransferConfirmed,
  },
];

class TransferFundsContainer extends Component {
  onNext = async () => {
    const { match } = this.props;
    const nextRoute = this.getNextRoute();
    if (nextRoute) {
      this.props.navigate(`${match.url}/${nextRoute.path}`);
    }
  }

  getRouteIndex = (props) => {
    const { match, location } = props || this.props;
    const curPath = location.pathname.replace(new RegExp(`^${match.url}/`), '');
    return routes.findIndex(route => route.path === curPath);
  }

  getPreviousRoute = props => routes[this.getRouteIndex(props) - 1];
  getRoute = props => routes[this.getRouteIndex(props)];
  getNextRoute = props => routes[this.getRouteIndex(props) + 1];

  render() {
    const {
      match,
      accountNumber,
      location,
      restrictions,
    } = this.props;
    const backTo = this.getRouteIndex(this.props) === 0 ? `/account/${accountNumber}` :
      get(this.getPreviousRoute(this.props), 'path');
    const propsToPassToComponent = {
      accountNumber,
      onNext: this.onNext,
      backTo,
    };

    // FINRA restricted accounts can't invest
    if (restrictions.length > 0 && !location.pathname.endsWith('account-restriction')) {
      return <Redirect to={`${location.pathname}/account-restriction`} />;
    }
    return (
      <div>
        <Switch>
          <Route
            path={`${match.url}/account-restriction`}
            render={() => (
              <TransferError
                accountNumber={accountNumber}
              />)}
          />
          {routes.map(({ path, Comp }) => (Comp ?
            <Route
              key={path}
              exact
              path={`${match.url}/${path}`}
              render={props => <Comp {...props} {...propsToPassToComponent} />}
            /> : null
          ))}
          <Redirect to={`${match.url}/${routes[0].path}`} />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, { match: { params: { accountNumber } } }) => ({
  restrictions: get(state, `accountRestrictionsByAccount[${state.currentAccount}].data`, []),
  cashBalance: Number.parseFloat(get(state.accountCashBalanceByAccount[accountNumber], 'data.balanceAvailableForT1Trades')),
  accountNumber,
});

const mapDispatchToProps = {
  navigate,
};

export default connect(mapStateToProps, mapDispatchToProps)(TransferFundsContainer);



// WEBPACK FOOTER //
// ./src/components/TransferFunds/index.js